export default {
    title: [
      { required: true, message: 'O título do alerta é obrigatório.', trigger: 'blur' },
      { min: 1, max: 100, message: 'O título deve ter entre 1 e 100 caracteres.', trigger: 'blur' }
    ],
    content: [
      { required: true, message: 'O conteúdo do alerta é obrigatório.', trigger: 'blur' },
    ]
}
  